/* ddi-card-lamp-deal.js - P68 F-20261013-09.
   When the cart has a lamp with an unused deal slot, homeware collection cards show the lamp
   deal price as a sale: struck RRP, deal price, "Save $X", a sale badge, and the label reads
   "30% off with your lamp". Otherwise the card shows its normal price.
   Deal state is read from the cart drawer's offer prompt (snippets/ddi-cart-offer-prompt.liquid,
   re-rendered by Krown after every add), the same source the drawer sliders use, so the card
   and the cart can never disagree. Deal price = min(price, 70% of RRP), as in the drawer slider.
   Only cards that carry the homeware label (snippets/ddi-card-offer-label.liquid) are touched.
   The homeware PDP (snippets/ddi-pdp-lamp-deal.liquid) gets the same treatment: price block,
   sticky bar price, Afterpay line and cover-image badge. The multi-buy pills show what the cart
   will charge: the open deal slots at 30% off, the rest on the homewares ladder (2/4/6 = 10/20/30%),
   each item at the larger of its discount and any sale, averaged per item. */
(function () {
  if (window.__ddiCardLampDeal) return;
  window.__ddiCardLampDeal = true;

  var LABEL_DEAL = '30% off with your lamp';

  function cents(t) { var n = parseFloat(String(t || '').replace(/[^0-9.]/g, '')); return isNaN(n) ? 0 : Math.round(n * 100); }
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function moneyShort(c) { return c % 100 ? money(c) : '$' + (c / 100); }

  function dealOpen() {
    var pr = document.querySelector('#site-cart-sidebar .ddi-offer-prompt[data-ddi-offer-state]') ||
             document.querySelector('.ddi-offer-prompt[data-ddi-offer-state]');
    if (!pr) return 0;
    var st = pr.getAttribute('data-ddi-offer-state');
    var lamps = parseInt(pr.getAttribute('data-ddi-lamps'), 10) || 0;
    var open = parseInt(pr.getAttribute('data-ddi-open'), 10) || 0;
    return lamps > 0 && open > 0 && st !== 'another-lamp' && st !== 'none' ? open : 0;
  }

  function applyCard(label, on) {
    var card = label.closest('.card');
    if (!card) return;
    var priceEl = card.querySelector('[data-card-body] .card__price');
    var badges = card.querySelector('[data-card-img] .product-item__badges, .card__img .product-item__badges');
    if (!priceEl) return;

    // A swatch swap re-renders the body, so the original price is re-read from each new element.
    if (!priceEl.hasAttribute('data-ddi-orig')) priceEl.setAttribute('data-ddi-orig', priceEl.innerHTML);
    var orig = priceEl.getAttribute('data-ddi-orig');

    var deal = 0, rrp = 0;
    if (on) {
      var tmp = document.createElement('p'); tmp.innerHTML = orig;
      var was = tmp.querySelector('.card__price-was');
      rrp = was ? cents(was.textContent) : 0;
      if (was) was.remove();
      var sv = tmp.querySelector('.card__price-savings'); if (sv) sv.remove();
      var now = cents(tmp.textContent);
      if (rrp <= now) rrp = now;
      deal = Math.min(now, Math.round(rrp * 0.7));
      if (!(now > 0 && deal < now)) deal = 0;
    }

    var key = deal ? String(deal) : '';
    if ((priceEl.getAttribute('data-ddi-deal') || '') !== key) {
      if (deal) {
        priceEl.innerHTML = '<s class="card__price-was">' + money(rrp) + '</s> ' + money(deal) +
          ' <span class="card__price-savings">Save ' + money(rrp - deal) + '</span>';
        priceEl.setAttribute('data-ddi-deal', key);
      } else {
        priceEl.innerHTML = orig;
        priceEl.removeAttribute('data-ddi-deal');
      }
    }

    if (badges) {
      var mine = badges.querySelector('[data-ddi-deal-badge]');
      var sale = [].filter.call(badges.querySelectorAll('.product-item__badge:not([data-ddi-deal-badge])'), function (b) {
        return /^\s*-/.test(b.textContent);
      });
      if (deal) {
        var txt = rrp < 10000 ? '-' + Math.round((rrp - deal) * 100 / rrp) + '%' : '-' + moneyShort(rrp - deal);
        if (!mine) {
          mine = document.createElement('span');
          mine.className = 'product-item__badge';
          mine.setAttribute('data-ddi-deal-badge', '');
          mine.style.backgroundColor = label.getAttribute('data-sale-bg') || '';
          mine.style.color = label.getAttribute('data-sale-fg') || '';
          badges.appendChild(mine);
        }
        if (mine.textContent !== txt) mine.textContent = txt;
        sale.forEach(function (b) { if (b.style.display !== 'none') { b.style.display = 'none'; b.setAttribute('data-ddi-hid', ''); } });
      } else {
        if (mine) mine.remove();
        [].forEach.call(badges.querySelectorAll('[data-ddi-hid]'), function (b) { b.style.display = ''; b.removeAttribute('data-ddi-hid'); });
      }
    }

    var text = deal ? LABEL_DEAL : label.getAttribute('data-ddi-label');
    if (label.textContent !== text) label.textContent = text;
  }

  // PDP: each element keeps the theme's own markup (orig) and what this script last wrote, so a
  // variant change that re-renders it is picked up as the new original instead of being overwritten.
  function swap(el, build) {
    if (!el) return;
    if (el.__ddiWritten === undefined || el.innerHTML !== el.__ddiWritten) el.__ddiOrig = el.innerHTML;
    var want = build ? build(el.__ddiOrig) : el.__ddiOrig;
    if (el.innerHTML !== want) el.innerHTML = want;
    el.__ddiWritten = el.innerHTML;
  }

  // Homewares ladder, counted on the items the lamp deal does not cover (measured on the live cart).
  function tier(n) { return n >= 6 ? 30 : n >= 4 ? 20 : n >= 2 ? 10 : 0; }

  function applyPills(root, slots, rrp, now, deal) {
    var grp = root.querySelector('[data-ddi-mbpills]');
    if (!grp) return;
    var salePct = rrp > now ? (rrp - now) * 100 / rrp : 0;
    [].forEach.call(grp.querySelectorAll('[data-ddi-mbpill]'), function (btn) {
      var q = parseInt(btn.getAttribute('data-qty'), 10) || 1;
      var d = Math.min(q, slots), r = q - d;
      var each = Math.round((d * deal + r * Math.round(rrp * (100 - Math.max(salePct, tier(r))) / 100)) / q);
      var pct = Math.round((rrp - each) * 100 / rrp);
      swap(btn, deal ? function (o) {
        var t = document.createElement('div'); t.innerHTML = o;
        var sv = t.querySelector('.ddi-hero__mbpill__save'), ea = t.querySelector('.ddi-hero__mbpill__each');
        if (sv) { sv.className = 'ddi-hero__mbpill__save'; sv.textContent = 'Save ' + pct + '%'; }
        if (ea) ea.textContent = moneyShort(each) + ' ea';
        return t.innerHTML;
      } : null);
      if (btn.__ddiAria === undefined) btn.__ddiAria = btn.getAttribute('aria-label') || '';
      var aria = deal ? 'Buy ' + q + ', save ' + pct + ' percent' : btn.__ddiAria;
      if (btn.getAttribute('aria-label') !== aria) btn.setAttribute('aria-label', aria);
    });
  }

  function applyPdp(label, on) {
    var root = label.closest('.ddi-pdp-hero-section') || document;
    var block = root.querySelector('.ddi-hero__price-block');
    if (!block) return;
    if (block.__ddiWritten === undefined || block.innerHTML !== block.__ddiWritten) block.__ddiOrig = block.innerHTML;
    var tmp = document.createElement('div'); tmp.innerHTML = block.__ddiOrig;
    var now = cents((tmp.querySelector('.ddi-hero__price') || {}).textContent);
    var cmpEl = tmp.querySelector('.ddi-hero__price-compare');
    var rrp = cmpEl ? cents(cmpEl.textContent) : 0;
    if (rrp <= now) rrp = now;
    var deal = on ? Math.min(now, Math.round(rrp * 0.7)) : 0;
    if (!(now > 0 && deal < now)) deal = 0;
    var save = rrp - deal;
    var saveTxt = rrp < 10000 ? Math.round(save * 100 / rrp) + '%' : moneyShort(save);

    swap(block, deal ? function () {
      return '<span class="ddi-hero__price">' + money(deal) + '</span><span class="ddi-hero__price-compare">' +
        money(rrp) + '</span><span class="ddi-hero__price-save">Save ' + saveTxt + '</span>';
    } : null);
    swap(root.querySelector('.ddi-sticky-atc__price') || document.querySelector('.ddi-sticky-atc__price'), deal ? function () {
      return money(deal) + ' <del>' + money(rrp) + '</del>';
    } : null);
    swap(root.querySelector('.ddi-hero__afterpay'), deal ? function (o) {
      return o.replace(/\$[0-9,]+\.[0-9]{2}/, money(Math.round(deal / 4)));
    } : null);
    applyPills(root, on, rrp, now, deal);

    var covers = root.querySelectorAll('[data-ddi-rail-img="0"] > .ddi-hero__badges, .ddi-hero__badges--cover-only');
    for (var i = 0; i < covers.length; i++) {
      var c = covers[i];
      var mine = c.querySelector('[data-ddi-deal-badge]');
      var own = c.querySelectorAll('[data-ddi-card-save]:not([data-ddi-deal-badge])');
      if (deal) {
        var txt = '-' + saveTxt;
        if (!mine) {
          mine = document.createElement('span');
          mine.className = 'ddi-hero__badge ddi-hero__badge--red';
          mine.setAttribute('data-ddi-deal-badge', '');
          var after = c.querySelector('.ddi-hero__badge--blue');
          c.insertBefore(mine, after ? after.nextSibling : c.firstChild);
        }
        if (mine.textContent !== txt) mine.textContent = txt;
        [].forEach.call(own, function (b) { if (b.style.display !== 'none') { b.style.display = 'none'; b.setAttribute('data-ddi-hid', ''); } });
      } else {
        if (mine) mine.remove();
        [].forEach.call(c.querySelectorAll('[data-ddi-hid]'), function (b) { b.style.display = ''; b.removeAttribute('data-ddi-hid'); });
      }
    }

    var text = deal ? LABEL_DEAL : label.getAttribute('data-ddi-label');
    if (label.textContent !== text) label.textContent = text;
  }

  var queued = false;
  function run() {
    queued = false;
    var on = dealOpen();
    var labels = document.querySelectorAll('[data-ddi-card-offer]');
    for (var i = 0; i < labels.length; i++) applyCard(labels[i], on);
    var pdp = document.querySelectorAll('[data-ddi-pdp-offer]');
    for (var j = 0; j < pdp.length; j++) applyPdp(pdp[j], on);
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(run); } }

  run();
  // Drawer refreshes after an add, lazy slider tabs and swatch swaps all arrive as DOM changes.
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  ['cart:updated', 'theme:cart:updated', 'ajaxCart:updated', 'pageshow'].forEach(function (ev) { window.addEventListener(ev, schedule); });
})();
